<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { CDrawerOffset } from '@/models/CDrawerOffset.model';
import { TourSelector } from '@/enums/TourSelector.enum';

/**
 *
 * @version 1.0.0
 * @since
 */
export default defineComponent({
	name: 'CDrawer',
	props: {
		show: {
			required: false,
			type: Boolean,
			default: false,
		},
		offset: {
			required: false,
			type: Object as PropType<CDrawerOffset>,
			default: { left: '0', top: '0' } as CDrawerOffset,
		},
	},
	setup() {
		return {
			TourSelector,
		};
	},
});
</script>

<template>
	<transition name="slide">
		<div
			v-if="show"
			class="c-drawer"
			:style="{
				...(offset.top && { top: offset.top }),
				...(offset.left && { left: offset.left }),
				...(offset.bottom && { bottom: offset.bottom }),
				...(offset.right && { right: offset.right }),
			}"
			:data-tour="TourSelector.DRAWER"
		>
			<slot name="body" />
		</div>
	</transition>
</template>

<style scoped lang="scss">
.c-drawer {
	position: absolute;
	z-index: 10;
	overflow-y: auto;
	width: 300px;
	height: 100%;
	background-color: #E3F5FA;
	color: #212529;
	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
}

.slide-enter-from,
.slide-leave-to {
	opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
	transition: opacity 0.5s ease;
}

.slide-enter-to,
.slide-leave-from {
	opacity: 1;
}
</style>
